<template>
  <div class="py-12">
    <v-row no-gutters align="center" justify="center">
      <v-col class="text-left" cols="12" sm="12" md="8">
        <h1 class="mb-8 display-1 font-weight-bold">Criar nova senha</h1>
        <v-form ref="form" v-show="!successAlert" lazy-validation>
          <h4  class="mb-4 subtitle-1 font-weight-regular">Digite sua nova senha de acesso do Infohidro.</h4>
          <div class="form-input-group">
            <v-text-field
              class="mb-n4"
              id="password"
              color="secondary" 
              background-color="white"
              light
              v-model="password"
              :rules="[passwordRules]"
              outlined
              required
              prepend-inner-icon="mdi-lock"
              :append-icon="passwordRules === true ? 'done' : ''"
              :type="showPassword ? 'text' : 'password'"
            />
             <label for="password">Nova senha</label>
          </div>
          <v-checkbox class="mt-2" v-model="showPassword" color="secondary" label="Mostrar nova senha" />
          
          <div class="ml-3 my-3 white--text" >
            <v-row>
              <v-icon :color="leastSixCharacters ? $vuetify.theme.themes.light.success : ''">done</v-icon>
              <span class="ml-1">Pelo menos 6 caracteres</span>
            </v-row>

            <v-row class="mt-5">
              <v-icon :color="leastOneUpperCase ? $vuetify.theme.themes.light.success : ''">done</v-icon>
              <span class="ml-1">Pelo menos 1 letra maiúscula</span>
            </v-row>

            <v-row class="mt-5">
              <v-icon :color="leastOneNumber ? $vuetify.theme.themes.light.success : ''">done</v-icon>
              <span class="ml-1">Pelo menos 1 número</span>
            </v-row>
          </div>

          <v-btn class="mt-8 button-text secondary font-weight-regular" height="50" width="180" large @click="resetPassword" :loading="loading">
            Salvar a nova senha
          </v-btn>  
        </v-form>

        <div v-if="successAlert">
          <v-alert
            outlined
            type="success"
            text
          >
            A sua nova senha foi alterada. Agora, você poderá fazer o login.
          </v-alert>

          <v-row class="ml-0 mt-4" align="center">
            <v-btn class="button-text secondary" height="50" width="230" dark large color="#0071B0" @click="backLogin" :loading="loading">
              Voltar para a tela de login
            </v-btn>            
          </v-row>
        </div>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import routes from '../../router/routes';
export default {
  name: "ForgotPassword",
  data: () => ({
    password:  '',
    checkbox: false,
    loading: false,
    successAlert: false,
    showPassword: false,
  }),
  mounted () {
    window.addEventListener('keydown', this.handleEnter)
  },
  destroyed () {
    window.removeEventListener('keydown', this.handleEnter)
  },
  computed:{
    passwordRules(){

      if(!this.password){
        return 'Você precisa inserir sua nova senha.';
      }

      if( this.password.length < 6 || !/[A-Z]/.test(this.password) || !/[0-9]/.test(this.password)){
        return 'A senha deve ter pelo menos 6 caracteres, pelo menos 1 letra maiúscula e pelo menos 1 número.';
      }

      return true;
    },
    leastSixCharacters(){
      return this.password.length >= 6;
    },
    leastOneUpperCase(){
      return /[A-Z]/.test(this.password);
    },
    leastOneNumber(){
      return /[0-9]/.test(this.password);
    }
  },
  methods: {
    handleEnter (e) {
      if (e.key === 'Enter') {
        this.signIn()
      }
    },
    async resetPassword () {
      if (this.$refs.form.validate()) {
        this.successAlert = true;
      }
    },
    backLogin () {
      this.$router.push(routes.login.path);
    },
  }
}
</script>

<style scoped>

  label{
    order: -1;
    color: #ffffff
  }
  
  .v-input:focus-within + label{
    color: var(--v-secondary-base);
  }

  .form-input-group{
    display: flex; 
    flex-direction: column;
  }

  .form-input-group /deep/ .v-input__icon--append .v-icon{
    color: #52B347 !important;
  }

  /* .v-text-field--outlined /deep/ .v-input__control /deep/ .v-input__slot {
      background: #ffffff !important;
  } */
  
</style>
